import { NavLink } from 'react-router-dom';
import { PlusIcon } from '../icons';
import { NAV } from '../strings';
import { useCompany } from '../hooks/useCompany';
import { useInboxCount } from '../hooks/useInboxCount';
import { CountBadge } from '../components/Badge';
import { MOBILE_TABS_LEFT, MOBILE_TABS_RIGHT, type NavItem } from './navItems';

function Tab({ item, count }: { item: NavItem; count: number }) {
  const Icon = item.icon;
  return (
    <li>
      <NavLink to={item.to} end={item.end ?? false} className={({ isActive }) => (isActive ? 'bottom-tab bottom-tab-active' : 'bottom-tab')}>
        <span className="bottom-tab-icon">
          <Icon size={24} />
          {item.badge === 'inbox' ? <CountBadge count={count} label="att göra" /> : null}
        </span>
        <span className="bottom-tab-label">{item.label}</span>
      </NavLink>
    </li>
  );
}

/** Mobile bottom tabs, 56 px + safe-area, with the raised + button in the middle. */
export function BottomTabs({ onAdd }: { onAdd: () => void }) {
  const { company } = useCompany();
  const count = useInboxCount(company?.id);
  return (
    <nav className="bottom-tabs" aria-label="Huvudmeny">
      <ul className="bottom-tabs-list">
        {MOBILE_TABS_LEFT.map((item) => (
          <Tab key={item.to} item={item} count={count} />
        ))}
        <li className="bottom-tabs-add">
          <button type="button" className="bottom-tabs-add-button" aria-label={NAV.add} onClick={onAdd}>
            <PlusIcon size={26} />
          </button>
        </li>
        {MOBILE_TABS_RIGHT.map((item) => (
          <Tab key={item.to} item={item} count={count} />
        ))}
      </ul>
    </nav>
  );
}
